import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { FormatPalletStock, StockColumn } from 'src/app/domain/models/PalletStock';
import { FileMaxSize } from 'src/app/ui/util/file-max-size';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-format-pallet-stock',
  templateUrl: './format-pallet-stock.component.html',
  styleUrls: ['./format-pallet-stock.component.css'],

})
export class FormatPalletStockComponent implements OnInit {


  loading: boolean = false;
  formatPalletStock: FormatPalletStock[] = [];
  deletedColumns: StockColumn[] = []
  stockColumns:StockColumn[] = []
  selectedFormat: number | undefined
  selectedFormatName: string | undefined
  visibleCreateFormatPalletStock: boolean = false;
  headers: string[] = []
  stockFile: any
  visibleFileFormat: boolean = false

  fileMaxSize = FileMaxSize.stock;


  constructor(    private _router: Router,
      public translate: TranslateService,
      private _palletStockService: PalletStockGateway,
        private _messageService: MessageService
    )
    {

    }

  ngOnInit(): void {
    this.getFormats()
  }

  getFormats()
  {
    this.loading = true;
    this._palletStockService.getFormatPalletStock().subscribe({
      next: (v) => {
        this.formatPalletStock = v
        this.loading = false;
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockError') })
      }
    })
  }

  onEditFormat(formatId: number, formatName: string)
  {
    this.selectedFormat = formatId;
    this.selectedFormatName = formatName;
    this.visibleCreateFormatPalletStock = true;
  }

  onCancelFormat()
  {
    this.visibleCreateFormatPalletStock = false;
    this.headers = []
  }

  onSaveFormat()
  {
    this.visibleCreateFormatPalletStock = false;
        this.headers = []
    this.getFormats()
  }

  onVisibleCreateStock()
  {
    this.selectedFormat = undefined
    this.selectedFormatName = undefined
    this.visibleCreateFormatPalletStock = true;
  }

  onVisibleCreateFileFormat() {
    this.selectedFormat = undefined
    this.selectedFormatName = undefined
    this.visibleFileFormat = true
  }

    onSelectDocumentFile(event: any) {
      this.stockFile = event.files[0]
    }

    onClearDocumentFile() {
      this.stockFile = null
    }

    loadFormatFromExcel()
    {

      if(this.stockFile)
      {
        const reader: FileReader = new FileReader();

        reader.onload = (e: ProgressEvent<FileReader>) => {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });

        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Obtener la primera fila como cabecera (A1, B1, C1, etc.)
        const range = XLSX.utils.decode_range(worksheet['!ref']!);

        // Crear un nuevo rango que solo abarque la primera fila
        range.e.r = range.s.r; // Limita el rango a la primera fila
        const headerRange = XLSX.utils.encode_range(range);

        const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: headerRange });

        this.headers = sheetData[0] as string[];
      };

        reader.readAsArrayBuffer(this.stockFile);
        this.visibleCreateFormatPalletStock = true;
      }

    }

    onCloseFileFormat() {
      this.onClearDocumentFile()
      this.visibleFileFormat = false;
    }
}
